import { RepFieldAudit } from "@repo/models";
import { FC, useMemo } from "react";

import style from "./style.module.scss";

interface ScoreProps {
	id: string;
	repFieldAudit?: RepFieldAudit;
}

/**
 * responseMap key (question id) for a score component's property name. Field audit sections used to
 * give these components the bare question id ("123"); since the shared BaseFieldAudits generator they
 * get "this.responseMap.123". Both end in the question id.
 */
export function getResponseId(propertyName: string) {
	return propertyName?.split(".").pop();
}

export const IndividualScore: FC<ScoreProps> = (props) => {
	const score = useMemo(() => {
		if (!props.repFieldAudit.responseMap) return 0;

		return props.repFieldAudit.responseMap[getResponseId(props.id)]?.Score ?? 0;
	}, [props]);

	const scoreTotal = useMemo(() => {
		if (!props.repFieldAudit.responseMap) return 0;

		return props.repFieldAudit.responseMap[getResponseId(props.id)]?.ScoreOutOf ?? 0;
	}, [props]);

	const color = useMemo(() => {
		if (score === 0 && scoreTotal === 0) return style.info;
		if (score === scoreTotal) return style.success;
		if (score === 0) return style.error;
		return style.warning;
	}, [score, scoreTotal]);

	return (
		<span className={color}>
			({score}/{scoreTotal})
		</span>
	);
};
